export default "/kiban/_next/static/images/gold-481171a0eaeb0a62595698f34ef45541.gif";